module.exports = __webpack_public_path__ + "img/grillentanz7.d77f55a5.jpg";